import { render } from "./IndicatorSearch.vue?vue&type=template&id=18bf1fcc"
import script from "./IndicatorSearch.vue?vue&type=script&lang=js"
export * from "./IndicatorSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__